import { Ng3MosueWheelEvent } from './../mouse/mouse-canvas.service';
import { SceneService } from './../../components/scene.service';
import { ZStoreService } from './../../z-store.service';
import { Component, OnInit, Input, Output, EventEmitter, Renderer2 } from '@angular/core';
import { CanvasService } from '../../components/canvas.service';
import { RendererService } from '../../components/renderer.service';
import {
  Camera,
  Vector2,
  Vector3,
  MOUSE,
  OrthographicCamera,
  PerspectiveCamera,
  Quaternion,
  Spherical,
  Matrix4,
} from 'three';
import { MouseCanvasService } from '../mouse/mouse-canvas.service';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

interface Range {
  min: number;
  max: number;
}
function fitrange(value: number, range: Range): number {
  return Math.max(range.min, Math.min(range.max, value));
}
const EPS = 1e-6;
function isCameraOfType<T extends 'Orthographic' | 'Perspective'>(
  camera: OrthographicCamera | PerspectiveCamera | Camera,
  type: T,
) {
  if (camera instanceof OrthographicCamera && type === 'Orthographic') {
    return true;
  }
  if (camera instanceof PerspectiveCamera && type === 'Perspective') {
    return true;
  }
  return false;
}

function switchByCameraType<O, P, E>(
  camera: OrthographicCamera | PerspectiveCamera | Camera,
  orthographic: (camera: OrthographicCamera) => O,
  perspective: (camera: PerspectiveCamera) => P,
  elseType: (camera: Camera) => E,
) {
  if (camera instanceof OrthographicCamera) {
    return orthographic(camera);
  }
  if (camera instanceof PerspectiveCamera) {
    return perspective(camera);
  }
  return elseType(camera);
}

const MOUSE_BUTTONS = {
  LEFT: MOUSE.LEFT,
  MIDDLE: MOUSE.MIDDLE,
  RIGHT: MOUSE.RIGHT,
};
const KEYS = { LEFT: 37, UP: 38, RIGHT: 39, BOTTOM: 40 };
@Component({
  selector: 'ng3-orbit-controls',
  templateUrl: './orbit-controls.component.html',
  styleUrls: ['./orbit-controls.component.css'],
})
export class OrbitControlsComponent implements OnInit {
  @Input() enabled = true;
  @Input() enableDamping = false;
  @Input() dampingFactor = 0.25;
  @Input() enableZoom = true;
  @Input() zoomSpeed = 1.0;
  @Input() enableRotate = true;
  @Input() rotateSpeed = 1.0;
  @Input() enablePan = true;
  @Input() panSpeed = 1.0;
  @Input() screenSpacePanning = false; // if true, pan in screen-space
  @Input() keyPanSpeed = 7.0; // pixels moved per arrow key push

  // Set to true to automatically rotate around the target
  // If auto-rotate is enabled, you must call controls.update() in your animation loop
  @Input() autoRotate = false;
  @Input() autoRotateSpeed = 2.0; // 30 seconds per round when fps is 60

  // Set to false to disable use of the keys
  @Input() enableKeys = true;

  // The four arrow keys

  @Output() change = new EventEmitter<void>();

  // Mouse buttons

  private zoomRange = { min: 0, max: Infinity };

  readonly domElement = this.canvasService.domElement;
  // for reset

  private rotate = new RotateController(
    this,
    this.rotateSpeed,
    this.autoRotateSpeed,
  );

  private dolly = new DollyController(this);
  private pan = new PanController(this, this.panSpeed);
  readonly target = new Vector3();
  public state:
    | 'none'
    | 'busy'
    | 'rotate'
    | 'dolly'
    | 'pan'
    | 'touch-rotate'
    | 'touch-dolly-pan' = 'none';

  public scale = 1;
  private zoomChanged = false;

  private position = new Vector3();
  private zoom = 1.0;

  private target0 = this.target.clone();
  private position0 = this.position.clone();
  // private zoom0 = this.camera.zoom;
  private zoom0 = 1;

  stop = new Subject<void>();

  // _camera: PerspectiveCamera | OrthographicCamera = new PerspectiveCamera(
  //   50,
  //   0.75,
  //   1,
  //   1000,
  // );

  // @Input()
  // get camera(): PerspectiveCamera | OrthographicCamera {
  //   return this._camera;
  // }
  // set camera(c: PerspectiveCamera | OrthographicCamera) {
  //   // if (isCameraOfType<'Orthographic'>(c, 'Orthographic')) {
  //   //   this._camera= c as OrthographicCamera;
  //   // }
  //   this._camera = c;
  // }
  get camera(): OrthographicCamera | PerspectiveCamera {
    const result = this.rendererService.camera;
    if (result === undefined) {
      throw Error('Camera is not exist');
    }
    return result;
  }

  // OnInit() {
  //   console.log('orbit init');
  //   console.log('camera', this.rendererService.camera);
  // }
  constructor(
    private canvasService: CanvasService,
    private rendererService: RendererService,
    private mouse: MouseCanvasService,
  ) {
    this.mouse.downWithButton$
      .pipe(
        // tap(e => console.log(e)),
        takeUntil(this.stop),
      )
      .subscribe(
        // this.mouse.downWithButton$.subscribe(
        e => {
          console.log(this.camera.position);
          e.original.preventDefault();
          switch (e.original.button) {
            case MOUSE_BUTTONS.LEFT:
              if (this.enableRotate === false) {
                return;
              }
              this.rotate.activate();
              this.rotate.onMouseDown(e.position);
              this.state = 'busy';
              break;
            case MOUSE.RIGHT:
              this.pan.activate();
              this.pan.onMouseDown(e.position);
              this.state = 'busy';
            case MOUSE.MIDDLE:
              this.dolly.activate();
              this.dolly.onMouseDown(e.position);
              this.state = 'busy';
          }
        },
        e => console.error(e),
      );
    this.mouse.position$.pipe(takeUntil(this.stop)).subscribe(
      p => {
        this.rotate.onMouseMove(p);
        this.pan.onMouseMove(p);
        this.dolly.onMouseMove(p);
      },
      e => console.error(e),
    );
    this.mouse.up$.pipe(takeUntil(this.stop)).subscribe(
      () => {
        this.rotate.deactivate();
        this.pan.deactivate();
        this.dolly.deactivate();
        this.state = 'none';
      },
      e => console.error(e),
    );
    this.mouse.wheel$.pipe(takeUntil(this.stop)).subscribe(
      w => {
        this.dolly.activate();
        this.dolly.onMOuseWheel();
        this.state = 'dolly';

        // this.pan.activate(),
        // this.pan.onMouseMove(w.position);
      },
      e => console.log(e),
    );
  }
  saveState() {
    this.target0.copy(this.target);
    this.position0.copy(this.camera.position);
    this.zoom0 = this.zoom;
    // isCameraOfType<'Orthographic'>(this.camera, 'Orthographic');
  }

  reset() {
    this.target.copy(this.target0);
    this.camera.position.copy(this.position0);
    this.camera.zoom = this.zoom0;
    this.camera.updateProjectionMatrix();
    this.update();
  }

  update() {
    const offset = new Vector3();
    const quat = new Quaternion().setFromUnitVectors(
      this.camera.up,
      new Vector3(0, 1, 0),
    );
    const quatInverse = quat.clone().inverse();
    const lastPosition = new Vector3();
    const lastQuaternion = new Quaternion();
    const position = this.camera.position;
    // console.log(this.camera.position);
    offset.copy(position).sub(this.target);
    // rotate offset to "y-axis-is-up" space
    offset.applyQuaternion(quat);
    this.rotate.update(offset, this.target);
    this.pan.update(offset, this.target);
    // rotate offset back to "camera-up-vector-is-up" space
    offset.applyQuaternion(quatInverse);

    position.copy(this.target).add(offset);
    this.camera.lookAt(this.target);
    this.scale = 1;
    this.rendererService.setCamera(this.camera);
    this.rendererService.render();

    // update condition is:
    // min(camera displacement, camera rotation in radians)^2 > EPS
    // using small-angle approximation cos(x/2) = 1 - x^2 / 8

    if (
      this.zoomChanged ||
      lastPosition.distanceToSquared(this.camera.position) > EPS ||
      8 * (1 - lastQuaternion.dot(this.camera.quaternion)) > EPS
    ) {
      this.change.emit();
      lastPosition.copy(this.camera.position);
      lastQuaternion.copy(this.camera.quaternion);
      this.zoomChanged = false;

      return true;
    }
    return false;
  }

  private get autoRotationAngle() {
    return ((2 * Math.PI) / 60 / 60) * this.autoRotateSpeed;
  }

  ngOnInit() {}
  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
  }
  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    // console.log(this.camera);
  }
}

class MouseController {
  private _activated = false;
  protected start = new Vector2();
  protected end = new Vector2();
  protected delta = new Vector2();
  get activated() {
    return this._activated;
  }
  activate() {
    this._activated = true;
  }
  deactivate() {
    this._activated = false;
  }
  constructor(protected controller: OrbitControlsComponent) {}
  onMouseDown(position: Vector2) {
    if (this.activated) {
      this.start.set(position.x, position.y);
    }
  }
  onMouseUp() {
    this.deactivate();
  }
}

class RotateController extends MouseController {
  private polarAngleRange = { min: 0, max: Math.PI };
  private azimuthAngleRange = { min: -Infinity, max: Infinity };
  private distanceRange = { min: 0, max: Infinity };
  readonly spherical = new Spherical();
  readonly sphericalDelta = new Spherical();
  constructor(
    controller: OrbitControlsComponent,
    private speed: number,
    private autoRotateSpeed: number,
  ) {
    super(controller);
  }
  get polarAngle() {
    return this.spherical.phi;
  }
  get azimuthalAngle() {
    return this.spherical.theta;
  }
  update(offset: Vector3, target: Vector3) {
    // angle from z-axis around y-axis
    this.spherical.setFromVector3(offset);

    if (this.autoRotate && this.controller.state === 'none') {
      this.autoRotate();
    }

    this.spherical.theta += this.sphericalDelta.theta;
    this.spherical.phi += this.sphericalDelta.phi;

    // restrict theta to be between desired limits
    this.spherical.theta = fitrange(
      this.spherical.theta,
      this.azimuthAngleRange,
    );

    // restrict phi to be between desired limits
    this.spherical.phi = fitrange(this.spherical.phi, this.polarAngleRange);

    this.spherical.makeSafe();

    this.spherical.radius *= this.controller.scale;

    // restrict radius to be between desired limits
    this.spherical.radius = fitrange(this.spherical.radius, this.distanceRange);
    offset.setFromSpherical(this.spherical);
    if (this.controller.enableDamping) {
      this.sphericalDelta.theta *= 1 - this.controller.dampingFactor;
      this.sphericalDelta.phi *= 1 - this.controller.dampingFactor;
    } else {
      this.sphericalDelta.set(0, 0, 0);
    }
  }
  autoRotate() {
    this.rotateLeft(this.autoRotateSpeed);
  }
  onMouseMove(position: Vector2) {
    if (!this.activated) {
      return;
    }
    this.end.set(position.x, position.y);
    this.delta.subVectors(this.end, this.start).multiplyScalar(this.speed);
    const element = this.controller.domElement;
    this.rotateLeft((2 * Math.PI * this.delta.x) / element.clientHeight); // yes, height
    this.rotateUp((2 * Math.PI * this.delta.y) / element.clientHeight);
    this.start.copy(this.end);
    this.controller.update();
  }
  private rotateLeft(angle: number) {
    this.sphericalDelta.theta -= angle;
  }

  private rotateUp(angle: number) {
    this.sphericalDelta.phi -= angle;
  }
}

class PanController extends MouseController {
  readonly offset = new Vector3();
  constructor(controller: OrbitControlsComponent, private speed: number) {
    super(controller);
  }
  update(offset: Vector3, target: Vector3) {
    target.add(this.offset);
    if (this.controller.enableDamping === true) {
      this.offset.multiplyScalar(1 - this.controller.dampingFactor);
    } else {
      this.offset.set(0, 0, 0);
    }
  }

  onMouseWheel() {}
  onMouseMove(position: Vector2) {
    if (!this.activated) {
      return;
    }
    this.end.set(position.x, position.y);
    this.delta.subVectors(this.end, this.start).multiplyScalar(this.speed);
    this.pan(this.delta.x, this.delta.y);
    this.start.copy(this.end);
    this.controller.update();
  }
  private panLeft(distance: number, objectMatrix: Matrix4) {
    const v = new Vector3();
    v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
    v.multiplyScalar(-distance);
    this.offset.add(v);
  }

  private panUp(distance: number, objectMatrix: Matrix4) {
    const v = new Vector3();

    if (this.controller.screenSpacePanning === true) {
      v.setFromMatrixColumn(objectMatrix, 1);
    } else {
      v.setFromMatrixColumn(objectMatrix, 0);
      v.crossVectors(this.controller.camera.up, v);
    }

    v.multiplyScalar(distance);

    this.offset.add(v);
  }
  private pan(deltaX: number, deltaY: number) {
    const offset = new Vector3();
    const element = this.controller.domElement;

    switchByCameraType(
      this.controller.camera,
      camera => {
        this.panLeft(
          (deltaX * (camera.right - camera.left)) /
            camera.zoom /
            element.clientWidth,
          camera.matrix,
        );
        this.panUp(
          (deltaY * (camera.top - camera.bottom)) /
            camera.zoom /
            element.clientHeight,
          camera.matrix,
        );
      },
      camera => {
        const position = camera.position;
        offset.copy(position).sub(this.controller.target);
        let targetDistance = offset.length();

        // half of the fov is center to top of screen
        targetDistance *= Math.tan(((camera.fov / 2) * Math.PI) / 180.0);

        // we use only clientHeight here so aspect ratio does not distort speed
        this.panLeft(
          (2 * deltaX * targetDistance) / element.clientHeight,
          camera.matrix,
        );
        this.panUp(
          (2 * deltaY * targetDistance) / element.clientHeight,
          camera.matrix,
        );
      },
      () => {
        console.warn(
          'WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.',
        );
        this.controller.enablePan = false;
      },
    );
  }
}

class DollyController extends MouseController {
  private range = { min: 0, max: Infinity };
  private changed = false;
  get zoomChanged() {
    return this.changed;
  }
  constructor(controller: OrbitControlsComponent) {
    super(controller);
  }
  private get zoomScale() {
    return Math.pow(0.95, this.controller.zoomSpeed);
  }
  onMouseMove(position: Vector2) {
    if (!this.activated) {
      return;
    }
    this.end.set(position.x, position.y);
    this.delta.subVectors(this.end, this.start);
    if (this.delta.y > 0) {
      this.dollyIn(this.zoomScale);
    } else if (this.delta.y < 0) {
      this.dollyOut(this.zoomScale);
    }
    this.start.copy(this.end);
    this.controller.update();
  }

  onMOuseWheel() {
    if (!this.activated) {
      return;
    }
    // this.end.set(position.x, position.y);
    this.delta.subVectors(this.end, this.start);
    if (this.delta.x > 0) {
      this.dollyIn(this.zoomScale);
    } else if (this.delta.x < 0) {
      this.dollyOut(this.zoomScale);
    }
    // this.start.copy(this.end);
    this.controller.update();
  }
  private dollyIn(dollyScale: number) {
    switchByCameraType(
      this.controller.camera,
      camera => {
        camera.zoom = fitrange(camera.zoom * dollyScale, this.range);
        camera.updateProjectionMatrix();
        this.changed = true;
      },
      () => {
        this.controller.scale /= dollyScale;
      },
      () => {
        console.warn(
          'WARNING: OrbitControls encountered an unknown camera type - dolly/zoom disabled.',
        );
        this.controller.enableZoom = false;
      },
    );
    // if (this.controller.camera instanceof PerspectiveCamera) {
    //   this.controller.scale /= dollyScale;
    // } else if (this.controller.camera instanceof OrthographicCamera) {
    //   this.controller.camera.zoom = fitrange(
    //     this.controller.camera.zoom * dollyScale,
    //     this.range,
    //   );
    //   this.controller.camera.updateProjectionMatrix();
    //   this.changed = true;
    // } else {
    //   console.warn(
    //     'WARNING: OrbitControls encountered an unknown camera type - dolly/zoom disabled.',
    //   );
    //   this.controller.enableZoom = false;
    // }
  }

  private dollyOut(dollyScale: number) {
    switchByCameraType(
      this.controller.camera,
      camera => {
        camera.zoom = fitrange(camera.zoom / dollyScale, this.range);
        camera.updateProjectionMatrix();
        this.changed = true;
      },
      () => {
        this.controller.scale *= dollyScale;
      },
      () => {
        console.warn(
          'WARNING: OrbitControls encountered an unknown camera type - dolly/zoom disabled.',
        );
        this.controller.enableZoom = false;
      },
    );
  }
}
